import { Fragment } from 'react';
import { Button } from '@mui/material';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';

import { actionButtonSx } from '../../utils/queueMeta';

export function QueueGeopostLayerItemActions() {
    return (
        <Fragment>
            <Button size='small' variant='outlined' startIcon={<MapOutlinedIcon sx={{ fontSize: 16 }} />} sx={actionButtonSx}>
                Abrir no Mapa
            </Button>
            <Button size='small' variant='outlined' startIcon={<StorageOutlinedIcon sx={{ fontSize: 16 }} />} sx={actionButtonSx}>
                Mostrar Dados
            </Button>
        </Fragment>
    );
}
